// extracted by mini-css-extract-plugin
export default {"button":"Do-z","reviewSort":"Eo-z"};